export function CareerMilestonesDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Career Milestone Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Milestone Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Milestone Type <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select milestone type</option>
              <option value="first_job">First Job</option>
              <option value="promotion">Promotion</option>
              <option value="role_change">Role Change</option>
              <option value="leadership">Leadership Position</option>
              <option value="career_peak">Career Peak</option>
            </select>
          </div>

          {/* Company Name */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Company Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter company name"
            />
          </div>

          {/* Job Title */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Job Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter job title"
            />
          </div>

          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Department */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Department
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter department name"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Salary Range (Optional) */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Salary Range
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select range</option>
              <option value="entry">Entry Level (0-40k)</option>
              <option value="mid">Mid Level (40k-80k)</option>
              <option value="senior">Senior Level (80k-120k)</option>
              <option value="executive">Executive Level (120k+)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  )
} 